import { Controller, useFormContext } from "react-hook-form";
import RichTextEditor from "@/components/RichTextEditor";
import { handleEditorChangeToHtml } from "@/lib/htmlHelpers";
import { initializeRichTextForEdit } from "@/pages/events/_form/utils/markdownUtils";

interface RichTextToMarkdownProps {
  fieldName: string;
  placeholder?: string;
}

const RichTextToMarkdown = ({ fieldName, placeholder }: RichTextToMarkdownProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { onChange, value } }) => (
        <RichTextEditor
          placeholder={placeholder || ""}
          onInitialState={(editor) => initializeRichTextForEdit(editor, value)}
          onChange={(editorState) => handleEditorChangeToHtml(editorState, onChange)}
        />
      )}
    />
  );
};

export default RichTextToMarkdown;
